export default "__VITE_ASSET__a29c1573__"